<template>
  <div class="content">
    <div class="title">全局视图</div>
    <div class="report-column">
      <div class="search-column">
        <div style="flex-basis: 200px;">
          分属部门
        </div>
        <el-input></el-input>
        <div style="flex-basis: 200px;">起止时间
        </div>
        <el-input></el-input>
        <el-button type="primary" icon="el-icon-search">搜索</el-button>
      </div>
      <div class="status-list">
        <div class="pro-title">
          <div class="item" v-for="item in statusColor" :key="item.id">
            <div class="proxx" :style="{ backgroundColor: item.color }"></div>
            {{ item.name }}
          </div>
        </div>
      </div>
    </div>
    <div>
      <div style="font-weight: 600;font-size: 1.2em;">项目进度报表</div>
      <div style="display: flex; padding: 10px 15px;">
        <div class="process-item ">
          <div>
            <p>项目</p>
            <p class="num">10</p>
          </div>
          <div>
            <p>总任务</p>
            <p class="num">255</p>
          </div>
        </div>
        <div class="process-item mid">
          <div>
            <p>未开始</p>
            <p class="num">252</p>
          </div>
          <div>
            <p>进行中</p>
            <p class="num">1</p>
          </div>
          <div>
            <p>已完成</p>
            <p class="num">2</p>
          </div>
        </div>
        <div class="process-item">
          <el-progress type="dashboard" :percentage="proData.num" :width="proData.width" color="#f00"></el-progress>
        </div>
      </div>
    </div>
    <el-table :data="tableData" style="width: 100%">
      <el-table-column type="expand">
        <template slot-scope="props">
          <div label-position="left" inline class="demo-table-expand">
            <div>
              <Progre :progressContent="list" />
            </div>
          </div>
        </template>
      </el-table-column>
      <el-table-column label="项目" prop="p1">
      </el-table-column>
      <el-table-column label="项目状态" prop="p2">
      </el-table-column>
      <el-table-column label="总任务" prop="p3">
      </el-table-column>
      <el-table-column label="未开始" prop="p4">
      </el-table-column>
      <el-table-column label="进行中" prop="p5">
      </el-table-column>
      <el-table-column label="已完成" prop="p6">
      </el-table-column>
      <el-table-column label="已逾期" prop="p7">
      </el-table-column>
      <el-table-column label="逾期完成" prop="p8">
      </el-table-column>
      <el-table-column label="风险数量" prop="p9">
      </el-table-column>
      <el-table-column label="问题数量" prop="p10">
      </el-table-column>
      <el-table-column label="完成率">
        <template slot-scope="scope">
          <el-progress :percentage="scope.row.p11"></el-progress>
        </template>
      </el-table-column>
    </el-table>
  </div>
</template>

<script>
import { gloalViewData } from "./riskData";
import Progre from "./progre.vue";
export default {
  data() {
    return {
      tableData: [],
      proData: {
        number: 12,
        width: 90
      },
      list: [
        { name: '概念设计', percentComplete: 0, color: 2 },
        { name: '设计图纸', percentComplete: 0, color: 2 },
        { name: '硬件图纸设计', percentComplete: 0, color: 2 },
        { name: '样机测试', percentComplete: 0, color: 2 },
        { name: '批量生产', percentComplete: 0, color: 2 },
        { name: '项目结项', percentComplete: 0, color: 2 },
      ],
      statusColor: [
        { id: 1, color: "#13ce66", name: '健康阶段' },
        { id: 2, color: "#fcad2c", name: '危险阶段' },
        { id: 3, color: "#F56C6C", name: '需要注意' },
        { id: 5, color: '#e5e9f2', name: '未开始' }
      ],
    }
  },
  components: { Progre },
  created() {
    this.tableData = gloalViewData
  },
}
</script>

<style scoped>
.content {
  padding: 25px;
  padding-top: 5px;
}

.title {
  margin: 10px auto;
  font-size: 1.4em;
  font-weight: 600;
  text-align: left;
}

.report-column {
  /* width: 600px; */
  margin: 15px auto;
  display: flex;
  gap: 1em
}

.search-column {
  display: flex;
  width: 800px;
  font-size: 12px;
  gap: 0.6em;
  align-items: center;
}

.status-list {
  margin-left: auto;
  width: 240px;
}

.demo-table-expand {
  font-size: 0;
}

.demo-table-expand label {
  width: 90px;
  color: #99a9bf;
}

.demo-table-expand .el-form-item {
  margin-right: 0;
  margin-bottom: 0;
  width: 50%;
}

.process-item {
  display: flex;
  flex: 1;
  justify-content: space-around;

}

.mid {
  border-left: 1px solid #eee;
  border-right: 1px solid #eee;
}

.num {
  font-weight: 600;
  margin: 10px 0;
}

.pro-title {
  height: 28px;
  line-height: 28px;
  padding: 0;
  font-size: 14px;
}

.pro-title .item {
  height: 28px;
  width: 88px;
  display: inline-block;
}

.proxx {
  width: 12px;
  height: 12px;
  border-radius: 6px;
  /* background: crimson; */
  display: inline-block;
  /* border: crimson 1px solid; */
  /* background-color: #13ce66; */
  color: #e5e9f2;
}
</style>